import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/services/")({
  head: () => ({ meta: [{ title: "Services | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-services-index")),
});
